import { Col, Row } from 'react-bootstrap'
import { Check, Circle } from 'phosphor-react'
import React from 'react'
import styles from './styles.module.css'

const DeliveryTracking = ({ requests, requestOrder, delivered }) => {
  function getFirstRequestOnRoute() {
    var order
    requests.every((request) => {
      if (request.status === 'on_route') {
        order = request.order
        return false
      }
      return true
    })
    return order
  }

  return (
    <Row
      className={`${styles.container} d-flex flex-row justify-content-center align-items-center`}
    >
      {requests.slice(0, requestOrder - 1).map((request, index) => (
        <React.Fragment key={index}>
          <Col
            className="d-flex flex-column align-items-center"
            style={{ padding: 0, margin: 0 }}
            key={index}
          >
            <Row style={{ margin: 0 }}>
              <div className={styles.requestOrderContainer}>
                <p
                  style={{
                    margin: 0,
                    fontWeight: 700,
                  }}
                >
                  0{index + 1}
                </p>
              </div>
            </Row>
            <Row style={{ margin: 0 }}>
              {request.status === 'delivered' ? (
                <div className={`${styles.deliveredIcon} ${styles.deliveredBlue}`} height={50}>
                  <Check color="white" size="30px" weight="bold" />
                </div>
              ) : (
                <>
                  {request.order === getFirstRequestOnRoute() ? (
                    <>
                      {request.order === requestOrder ? (
                        <div className={`${styles.onRouteIcon} ${styles.redBorder}`}>
                          <Circle color="#FFFFFF" size="20px" weight="" />
                        </div>
                      ) : (
                        <div className={`${styles.onRouteIcon} ${styles.blueBorder}`}>
                          <Circle color="#FFFFFF" size="20px" weight="fill" />
                        </div>
                      )}
                    </>
                  ) : (
                    <div className={`${styles.onRouteIcon} ${styles.grayBorder}`}>
                      <Circle color="#FFFFFF" size="20px" weight="fill" />
                    </div>
                  )}
                </>
              )}
            </Row>
          </Col>
          <Col
            className={`${styles.lineContainer} d-flex justify-content-center align-items-center`}
          >
            <p className={styles.line}></p>
          </Col>
        </React.Fragment>
      ))}
      <Col
        className="d-flex flex-column align-items-center"
        style={{
          padding: 0,
        }}
      >
        <Row>
          <div className={styles.custormerRequestText}>
            <span>Sua</span>
            <span>entrega</span>
          </div>
        </Row>
        <Row>
          {delivered ? (
            <div className={`${styles.deliveredIcon} ${styles.deliveredRed}`}>
              <Check color="white" size="30px" weight="bold" />
            </div>
          ) : (
            <>
              {getFirstRequestOnRoute() !== requestOrder ? (
                <div className={`${styles.onRouteIcon} ${styles.grayBorder}`}>
                  <Circle color="#FFFFFF" size="20px" weight="fill" />
                </div>
              ) : (
                <div className={`${styles.onRouteIcon} ${styles.redBorder}`}>
                  <Circle color="#FFFFFF" size="20px" weight="fill" />
                </div>
              )}
            </>
          )}
        </Row>
      </Col>
    </Row>
  )
}

export default DeliveryTracking
